module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'vloh464q',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
